import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Eraser } from "lucide-react";
import { api } from "../../lib/api";

const opts = { withCredentials: true };

export const StatsCleanup = ({ onDone }) => {
  const [open, setOpen] = useState(false);
  const [extracts, setExtracts] = useState([]);
  const [useAge, setUseAge] = useState(true);
  const [days, setDays] = useState(7);
  const [ids, setIds] = useState([]);
  const [preview, setPreview] = useState(null);
  useEffect(() => { if (open) api.get("/admin/extracts", opts).then((r) => setExtracts(r.data)).catch(() => {}); }, [open]);
  const payload = (dry) => ({ older_than_days: useAge ? Number(days) : null, reset_extract_ids: ids, dry_run: dry });
  useEffect(() => {
    if (!open) return;
    api.post("/admin/extract-stats/cleanup", payload(true), opts).then((r) => setPreview(r.data)).catch(() => setPreview(null));
  }, [open, useAge, days, ids]); // eslint-disable-line react-hooks/exhaustive-deps
  const run = async () => {
    if (!window.confirm(`Supprimer définitivement ${preview.sessions} lecture(s) et ${preview.partner_scans} scan(s) ? Cette action est irréversible.`)) return;
    try { await api.post("/admin/extract-stats/cleanup", payload(false), opts); toast.success("Statistiques nettoyées"); setIds([]); onDone?.(); setOpen(false); }
    catch { toast.error("Nettoyage impossible"); }
  };
  const toggle = (id) => setIds(ids.includes(id) ? ids.filter((x) => x !== id) : [...ids, id]);

  if (!open) return <button onClick={() => setOpen(true)} data-testid="stats-cleanup-open" className="flex items-center gap-2 border border-[#9E4735] text-[#9E4735] px-3 py-1.5 text-xs font-body hover:bg-[#9E4735] hover:text-[#FAF9F6] transition-colors"><Eraser size={13} /> Nettoyer les statistiques</button>;
  return (
    <div data-testid="stats-cleanup" className="basis-full border border-[#9E4735] bg-[#9E4735]/5 p-5 font-body text-sm space-y-4">
      <p className="font-semibold text-[#9E4735]">Nettoyer les statistiques (lectures de test)</p>
      <label className="flex flex-wrap items-center gap-2"><input type="checkbox" checked={useAge} onChange={(e) => setUseAge(e.target.checked)} data-testid="stats-cleanup-age-toggle" />
        Supprimer tout l'historique de plus de <input type="number" min={1} value={days} onChange={(e) => setDays(e.target.value)} data-testid="stats-cleanup-days" className="w-16 border border-[#D1CFC7] px-2 py-1 bg-[#FAF9F6]" /> jours (toutes histoires)
      </label>
      <div>
        <p className="mb-2">Réinitialiser entièrement les statistiques de ces histoires :</p>
        <div className="flex flex-wrap gap-x-5 gap-y-2">
          {extracts.map((e) => <label key={e.id} className="flex items-center gap-2"><input type="checkbox" checked={ids.includes(e.id)} onChange={() => toggle(e.id)} data-testid={`stats-cleanup-extract-${e.slug}`} /> {e.title}</label>)}
        </div>
      </div>
      <p data-testid="stats-cleanup-preview" className="text-xs text-[#4A4A4A]">{preview ? `Seront supprimés : ${preview.sessions} lecture(s) et ${preview.partner_scans} scan(s) de QR partenaire. Les abonnés newsletter, commandes et ventes ne sont pas touchés.` : "Calcul…"}</p>
      <div className="flex gap-3">
        <button onClick={run} disabled={!preview || (!preview.sessions && !preview.partner_scans && !ids.length)} data-testid="stats-cleanup-run" className="bg-[#9E4735] text-[#FAF9F6] px-4 py-2 text-xs disabled:opacity-50">Supprimer définitivement</button>
        <button onClick={() => setOpen(false)} data-testid="stats-cleanup-cancel" className="border border-[#1A1A1A] px-4 py-2 text-xs">Annuler</button>
      </div>
    </div>
  );
};
